/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-06-11 09:47:19
 * @LastEditors: voanit
 * @LastEditTime: 2021-07-28 10:21:23
 */
import { request } from './request'

export const getPurchaseList = (data) => {
  const url = '/ocean/api/v1/product/purchase/list'
  return request({
    method: 'POST',
    url: url,
    data: data
  })
}

export const getPurchaseDetailList = (data) => {
  const url = '/ocean/api/v1/product/purchaseItem/list'
  return request({
    method: 'POST',
    url: url,
    data: data
  })
}

export const addPurchaseOrder = (data) => {
  const url = '/ocean/api/v1/product/purchase/saveOrUpdate'
  return request({
    method: 'POST',
    url: url,
    data: data
  })
}

export const getPurchaseDetail = (id) => {
  const url = `/ocean/api/v1/product/purchase/detail/${id}`
  return request({
    method: 'GET',
    url: url,
  })
}

export const getSkuList = (data) => {
  const url = '/ocean/api/v1/product/purchase/sku'
  return request({
    method: 'post',
    url: url,
    data
  })
}

export const checkPurchaseOrder = (id, status) => {
  const url = `/ocean/api/v1/product/purchase/updateStatus/${id}/${status}`
  return request({
    method: 'put',
    url: url,
  })
}

export const deletePurchaseOrder = (id) => {
  const url = `/ocean/api/v1/product/purchase/delete/${id}`
  return request({
    method: 'DELETE',
    url: url,
  })
}
